import { render, staticRenderFns } from "./WebsitePostRead.vue?vue&type=template&id=5109fea7"
import script from "./WebsitePostRead.vue?vue&type=script&lang=js"
export * from "./WebsitePostRead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports